import { useMutation, useQuery } from "@tanstack/react-query";
import { salaryManageKeys } from "apis/salary/query_keys_salary";
import {
  createSalaryReport,
  deleteSalary,
  getSalaryList,
  getSalaryReportCreateParam,
  getSalarySearchParam,
} from "apis/salary/salary_list_api";
import { simpleAlert } from "components/CommonLib/CommonLib";
import { useDispatch } from "react-redux";

// [GET] 급여 관리 검색 조건 받아오기 및 권한 데이터 세팅
export const useSalarySearchParam = (enabled) => {
  const storesDispatch = useDispatch();
  return useQuery({
    queryKey: salaryManageKeys.searchParam(),
    queryFn: () => getSalarySearchParam(),
    enabled: enabled,
    retry: false,

    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
  });
};

// [GET] 급여 관리 내역 리스트 검색
export const useSalaryList = (queryData, enabled, setEnabled) => {
  const storesDispatch = useDispatch();

  return useQuery({
    queryKey: salaryManageKeys.salaryList(queryData),
    queryFn: () => getSalaryList(queryData),
    enabled: enabled,
    retry: false,
    cacheTime: 0,

    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
    onSettled: () => {
      setEnabled(false);
    },
  });
};

// [GET] 급여 리포트 생성 조건 받아오기
export const useSalaryReportCreateParam = () => {
  const storesDispatch = useDispatch();

  return useQuery({
    queryKey: salaryManageKeys.salaryReportCreateParam(),
    queryFn: () => getSalaryReportCreateParam(),
    enabled: true,
    retry: false,
    cacheTime: 0,
    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "알림", res.data.msg);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
  });
};

// [DELETE] 급여 관리 내역 삭제
export const useDeleteSalary = (setIsGetSalaryList) => {
  const storesDispatch = useDispatch();

  return useMutation({
    mutationFn: (salaryReportId) => deleteSalary(salaryReportId),
    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "ERROR", res.data.msg);
      } else {
        simpleAlert(storesDispatch, "알림", "삭제되었습니다.");
        // 기존 급여 목록 데이터 다시 받아오기
        setIsGetSalaryList(true);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
  });
};

// [POST] 급여 리포트 생성
export const useCreateSalaryReport = (onModalDone) => {
  const storesDispatch = useDispatch();

  return useMutation({
    mutationFn: (createParam) => createSalaryReport(createParam),
    onSuccess: (res) => {
      if (res.data.msg) {
        simpleAlert(storesDispatch, "ERROR", res.data.msg);
      } else {
        simpleAlert(storesDispatch, "알림", "급여 리포트 생성이 완료되었습니다.");
        // 기존 급여 목록 데이터 다시 받아오기
        onModalDone(true);
      }
    },
    onError: (err) => {
      simpleAlert(storesDispatch, "ERROR", err.response.data ? err.response.data.msg : err.code);
    },
  });
};
